// The English table (ship 3): the same keys, kinds and placeholders as th.js — apps/name-tag/test/tables.test.js
// holds the two together. Brand names, units and the fixed sample words of a script stay as they are.
const ART_GONE = 'This art is too detailed for the size — enlarge it';
const BASE_PIECES = 'Parts on the tag sit too far apart to bridge a base — add a base margin, bring them closer, or shrink the art';
const INTERNAL = 'Something went wrong — try again';
const FATAL = 'Could not load the model builder — refresh the page';
const S = {
  title: "4-layer name tag",
  cap: "Letter height (mm)",
  spacing: "Letter spacing",
  textHint: "Press Enter for a new line · up to 3 lines",
  dir: {
    h: "Horizontal",
    v: "Vertical",
  },
  align: {
    h: {
      start: "Left",
      center: "Center",
      end: "Right",
    },
    v: {
      start: "Top",
      center: "Middle",
      end: "Bottom",
    },
  },
  lineGap: "Line spacing",
  layers: "Colour layers",
  layerCount: "Layer count",
  base: "Base",
  ring: "Rim",
  textLayer: "Letters",
  width: "Width",
  height: "Thickness",
  mm: " mm",
  looks: "Colour sets",
  loop: "Keychain loop",
  pos: {
    none: "None",
    left: "Left",
    right: "Right",
    top: "Top",
  },
  hole: "Hole width",
  ringW: "Loop rim",
  print: "Printing",
  layerHeight: "Layer height",
  mode: {
    multi: "Multi (CFS / AMS)",
    swap: "Single nozzle",   // R72: the pill row's own label says it is how colour is printed
  },
  zTable: (color, z, layer) => `Switch to ${color} at ${z.toFixed(2)} mm (layer ${layer})`,
  size: (w, h, z) => `${w.toFixed(1)} × ${h.toFixed(1)} × ${z.toFixed(1)} mm`,
  dlstl: "Download STL",
  copied: "Copied",
  stillBuilding: "Still building — long multi-line text can take about a minute",
  loadingFont: (got, total) => `Loading font ${got.toFixed(1)} / ${total.toFixed(1)} MB`,
  notice: {
    loadFailed: (family) => `Could not load ${family} — check the connection · keeping the current font`,
    capRaised: (family, cap) => `Letter height set to ${cap} mm — the smallest size ${family} prints clearly`,
  },
  issue: {
    "missing-glyph": p => `The font ${String(p.font).replace(/@\d+$/, '')} lacks the characters: ${p.chars.join(' ')}`,
    "thin-ring": p => `Layer ${p.band + 1}'s rim is too thin (${p.w} mm) — it should be ≥ 0.8 mm`,
    "thin-stroke": p => p.minCap
      ? `This font prints clearly from ${p.minCap} mm — raise letter height to at least ${p.minCap} mm`
      : `The strokes of ${p.chars.join(' ')} are thinner than the 0.4 mm nozzle — go larger or pick a heavier font`,
    "bed-fit": p => `The tag is ${p.w.toFixed(0)} × ${p.h.toFixed(0)} mm — it may exceed a 220 mm print bed`,
    "loop-float": () => 'The loop is not attached to the tag — move it or add a base margin',
    "thin-art": () => 'Some strokes of the art are thinner than the 0.4 mm nozzle — enlarge it or use art with heavier strokes',
    "icon-max": (p) => `Art can be at most ${p.max} mm — shown at that size`,
    "art-gone": () => ART_GONE,
    "base-pieces": () => BASE_PIECES,
  },
  errorCode: {
    "build-timeout": "A build did not finish in 2 minutes and was restarted — try fewer letters or another font",
    stale: "A newer change arrived",
    empty: "No letters to print",
    "font-load": "The font did not load",
    internal: "Something went wrong — try again",
    "base-pieces": "Parts on the tag sit too far apart to bridge a base — add a base margin, bring them closer, or shrink the art",
    "art-gone": "This art is too detailed for the size — enlarge it",
    engine: "Something went wrong — try again",
    fatal: "Could not load the model builder — refresh the page",
  },
  fatal: "Could not load the model builder — refresh the page",
  icon: "Art or logo (SVG)",
  unpick: "Remove the art",
  iconPos: {
    left: "Left",
    right: "Right",
    above: "Above",
  },
  iconSize: "Art size",
  iconGap: "Gap",
  pct: (k) => `${Math.round(k * 100)}%`,
  needFile: "Choose the art or logo’s SVG file — it stays on your device and is sent nowhere",
  artKept: "The art lives only in this tab — after a refresh you must choose the file again",
  keptOld: "(still using the previous art)",
  thumb: "Preview of the art read",
  shareNoIcon: "This link carries no art file — whoever opens it must choose the SVG themselves",
  linkNeedsIcon: "This design uses art from a file, which the link does not carry — choose an SVG file to add it",

  // ship 3 piece c: the template's static text, baked per language by the build (was hardcoded Thai)
  aboutP: "Design a 2–4 colour name tag or key fob. Print names in Thai, English, Chinese or Japanese — on several lines or vertically — choose a font, then download a 3MF for a multi-colour printer or an STL for single-colour printing. Free in the browser, nothing to install. Add a logo or icon from an SVG file next to the name — the file stays on your device and is sent nowhere.",
};
export default S;
